import React from 'react';
import TopBar from "./top-bar";
import MainHeader from "./main-header";
import SzTopBar from "./sz-top-bar";
import SzMainHeader from "./sz-main-header";

const NavTopBar = ({partner}) => {
    return (
        <div className="header">
            {Number(partner.agency_no) === Number(process.env.REACT_APP_SZ_AGENCY_NO) ? (
                <>
                    <SzTopBar></SzTopBar>
                    <SzMainHeader></SzMainHeader>
                </>
            ) : (
                <>
                    <TopBar partner={partner}/>
                    <MainHeader partner={partner}/>
                </>
            )}
        </div>
    )
}

export default NavTopBar;